module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-300italic.woff?e125f1e2de9a2150a521f55c482b8151";